<template>
  <div>
    <k-dialog v-if="isOpened">
      <div :style="{ margin: '25px', textAlign: 'center', fontSize: '16px' }">
        <p>No CSV is found with this Invoice ID. You can close the window.</p>
      </div>
    </k-dialog>
  </div>
</template>
<script>
import { Dialog } from "@progress/kendo-vue-dialogs";


export default {
  name: "NoCSVMessage",
  components: {
    "k-dialog": Dialog,

  },
  props: ["openNoCSVMessageFlag"],
  data() {
    return {
      inputConfirmation: "",
      deleteInProgress: false,
    };
  },
  setup(props) {
    return {
      isOpened: props.openNoCSVMessageFlag,
      closeDialog: props.handleOpenNoCSVMessage,
    };
  },
  watch: {
    openNoCSVMessageFlag(val) {
      this.isOpened = val;
     
    },
  },
  methods: {
    toggleDialog() {
      this.closeDialog(!this.isOpened);
      this.isOpened = !this.isOpened;
    },
  },
};
</script>
